import { forwardRef } from 'react'
import PresupuestoTableInsights from './PresupuestoTableInsights'

const Presupuesto = forwardRef(function Presupuesto({ onDirty }, ref) {
  return <PresupuestoTableInsights ref={ref} onDirty={onDirty} />
}); 

export default Presupuesto
